import { render, staticRenderFns } from "./VExpandableText.vue?vue&type=template&id=202304e4"
import script from "./VExpandableText.vue?vue&type=script&lang=js"
export * from "./VExpandableText.vue?vue&type=script&lang=js"
import style0 from "./VExpandableText.vue?vue&type=style&index=0&id=202304e4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202304e4')) {
      api.createRecord('202304e4', component.options)
    } else {
      api.reload('202304e4', component.options)
    }
    module.hot.accept("./VExpandableText.vue?vue&type=template&id=202304e4", function () {
      api.rerender('202304e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VExpandableText.vue"
export default component.exports